const { registerBlockType } = wp.blocks;
const { __ } = wp.i18n;
const { MediaUpload, MediaUploadCheck, BlockControls, InspectorControls } = wp.blockEditor;
import { ToolbarGroup, ToolbarButton, Button, PanelBody, ToggleControl , TextControl, RangeControl, SelectControl,  __experimentalBoxControl as BoxControl, __experimentalBorderBoxControl as BorderBoxControl, __experimentalInputControl as InputControl, TextareaControl } from '@wordpress/components';
import image1 from "./lib/img/dummy-image.jpg";
import ReactCompareImage from 'react-compare-image';
registerBlockType('spice-block-plus/img-comparison',{
    title: __('Image Comparison','spice-blocks'),
    category: 'spice-blocks',
    icon:   
			<svg  width="24" height="24" viewBox="0 0 24 24"><path stroke="#09A223" fill="#09A223" d="M12 2H2v20h10V2z"></path><path d="M0 0v24h24V0zm22 22H2V2h20z" fill="#333"></path><path fill="#fff" d="M12 12v10h10V2H12v10z"></path><path fill="#333" d="M8 14h8v-4H8v4z"></path></svg>,
    keywords: [
        __( 'compare images' , 'spice-blocks' ),
        __( 'image compare' , 'spice-blocks' ),
        __( 'image comparison', 'spice-blocks' )
    ],  
    example: {
		"attributes": {
			"beforeImageUrl": image1,
			"afterImageUrl": image1
		}
	},
    attributes: {
		uniqueId: {
            type: 'string'
        },
        beforeImageId: {
			type: 'number'
		},
        beforeImageUrl: {
			type: 'string'
		},
        beforeImageAlt: {
			type: 'string'
		},
        afterImageId: {
			type: 'number'
		},
        afterImageUrl: {
			type: 'string'
		},
        afterImageAlt: {
			type: 'string'
		},
		hover: {
			type: 'boolean',
			default: false
		},
		showLabel: {
			type: 'boolean',
			default: false
		},
		leftImageLabel: {
			type: 'string',
			default: 'Before'
		},
		rightImageLabel: {
			type: 'string',
			default: 'After'
		},
		verticalMode: {
			type: 'boolean',
			default: false
		},
		fullWidth: {
			type: 'boolean',
			default: true
		},
		imgWidth: {
			type: 'number',
			default:70
		},
		AccordionAnimation:{
            type:'string',
            default:''
        },
        AccordionDurations:{
            type:'string'
        },
        AccordionDelay:{
            type:'string'
        }, 
        HideDesktop:{
            type: 'boolean',
            default: true
        },
        HideTablet:{
            type: 'boolean',
            default: true
        },
        HideMobile:{
            type: 'boolean',
            default: true
        },
		imgMargin: {
            default: {
                top: '20px',
                right: 'auto',
                bottom: '20px',
                left: 'auto'
            }
        },
        addclass:{
	    	type:'string',
	    },
	    customcss:{
	    	type:'string',
	    }
    },
    edit: function({attributes, setAttributes, clientId})      
    {
        const { uniqueId, beforeImageId, beforeImageUrl, beforeImageAlt, afterImageId, afterImageUrl, afterImageAlt, verticalMode, hover, showLabel, leftImageLabel, rightImageLabel, fullWidth, imgWidth, AccordionAnimation, AccordionDurations, AccordionDelay, HideDesktop, HideTablet, HideMobile, imgMargin, addclass, customcss  } = attributes;
		const animationclass='wow animated ' +attributes.AccordionDurations+' '+attributes.AccordionAnimation;
        const displaydesktop=(HideDesktop == false) ? 'hide-desktop' : '';
        const displaytablet=(HideTablet == false) ? 'hide-tablet' : '';
        const displaymobile=(HideMobile == false) ? 'hide-mobile' : '';
        const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;
        // set unique ID
		setAttributes({
			uniqueId: clientId.slice(0, 8),
		}); 
        
        return([<>
				<InspectorControls>
					<PanelBody initialOpen={true} title={__('General Settings','spice-blocks')}>
						<ToggleControl
							label={__('Enable/Disable Vertical Mode','spice-blocks')}
							checked={verticalMode}
							onChange={() => setAttributes({ verticalMode: !verticalMode })}
						/>
						<ToggleControl
							label={__('Enable/Disable Hover Effect','spice-blocks')}
							checked={hover}
							onChange={() => setAttributes({ hover: !hover })}
						/>
						<ToggleControl
							label={__('Enable/Disable Labels','spice-blocks')}
							checked={showLabel}
							onChange={() =>
								setAttributes({ showLabel: !showLabel })
							}
						/>
						 
						{showLabel && [<>
							<TextControl
								label="Before Image Label"
								value={leftImageLabel}
								onChange={(leftImageLabel) =>
									setAttributes({ leftImageLabel })
								}
							/>
							<TextControl
								label="After Image Label"
								value={rightImageLabel}
								onChange={(rightImageLabel) =>
									setAttributes({ rightImageLabel })
								}
							/>
							</>]}

						<ToggleControl
							label={__('Enable/Disable Image Width','spice-blocks')}
							checked={fullWidth}
							onChange={() =>
								setAttributes({ fullWidth: !fullWidth })
							}
						/>	
						{ fullWidth && [<>
							<RangeControl 
								label={__('Image Width (%)','spice-blocks')}
								value={imgWidth}
								min={0}
								max={100}
								onChange={(userVal) => setAttributes({imgWidth: userVal})}
							/>
						</>]}	

						<BoxControl 
							label={__('Margin ( Top & Bottom )','spice-blocks')}
							values={imgMargin}
							inputProps={{ min: -300 }}
							sides={['top', 'bottom']}
							allowReset={false}
							units={[]}
							onChange={(userVal) => setAttributes({
								imgMargin:{
								top:userVal.top,
								right:userVal.right,
								bottom:userVal.bottom,
								left:userVal.left
								}
							})}
						/>

						<PanelBody initialOpen={false} title={__('Animation Effect','spice-blocks')} className={'spice-panel-edit margin'}>
							<SelectControl
                            label={__('Animation','spice-blocks')}
                            value={ AccordionAnimation }
                            options={ [
                                { label: __('None','spice-blocks'), value: ' ' },
                                { label: __('Bounce','spice-blocks'), value: 'bounce' },
                                { label: __('Flash','spice-blocks'), value: 'flash' },
                                { label: __('Pulse','spice-blocks'), value: 'pulse' },
                                { label: __('RubberBand','spice-blocks'), value: 'rubberBand' },
                                { label: __('Shake','spice-blocks'), value: 'shake' },
                                { label: __('Swing','spice-blocks'), value: 'swing' },
                                { label: __('Tada','spice-blocks'), value: 'tada' },
                                { label: __('Wobble','spice-blocks'), value: 'wobble' },
                                { label: __('Jello','spice-blocks'), value: 'jello' },
                                { label: __('BounceIn','spice-blocks'), value: 'bounceIn' },
                                { label: __('BounceInDown','spice-blocks'), value: 'bounceInDown' },
                                { label: __('BounceInLeft','spice-blocks'), value: 'bounceInLeft' },
                                { label: __('BounceInRight','spice-blocks'), value: 'bounceInRight' },
                                { label: __('BounceInUp','spice-blocks'), value: 'bounceInUp' },
                                { label: __('FadeIn','spice-blocks'), value: 'fadeIn' },
                                { label: __('FadeInDown','spice-blocks'), value: 'fadeInDown' },
                                { label: __('FadeInDownBig','spice-blocks'), value: 'fadeInDownBig' },
                                { label: __('FadeInLeft','spice-blocks'), value: 'fadeInLeft' },
                                { label: __('FadeInLeftBig','spice-blocks'), value: 'fadeInLeftBig' },
                                { label: __('FadeInRight','spice-blocks'), value: 'fadeInRight' },
                                { label: __('FadeInRightBig','spice-blocks'), value: 'fadeInRightBig' },
                                { label: __('FadeInUp','spice-blocks'), value: 'fadeInUp' },
                                { label: __('FadeInUpBig','spice-blocks'), value: 'fadeInUpBig' },
                                { label: __('Flip','spice-blocks'), value: 'flip' },
                                { label: __('FlipInX','spice-blocks'), value: 'flipInX' },
                                { label: __('FlipInY','spice-blocks'), value: 'flipInY' },
                                { label: __('LightSpeedIn','spice-blocks'), value: 'lightSpeedIn' },
                                { label: __('RollIn','spice-blocks'), value: 'rollIn' },
                                { label: __('RotateIn','spice-blocks'), value: 'rotateIn' },
                                { label: __('RotateInDownLeft','spice-blocks'), value: 'rotateInDownLeft' },
                                { label: __('RotateInDownRight','spice-blocks'), value: 'rotateInDownRight' },
                                { label: __('RotateInUpLeft','spice-blocks'), value: 'rotateInUpLeft' },
                                { label: __('RotateInUpRight','spice-blocks'), value: 'rotateInUpRight' },
                                { label: __('SlideInDown','spice-blocks'), value: 'slideInDown' },
                                { label: __('SlideInLeft','spice-blocks'), value: 'slideInLeft' },
                                { label: __('SlideInRight','spice-blocks'), value: 'slideInRight' },
                                { label: __('ZoomIn','spice-blocks'), value: 'zoomIn' },
                                { label: __('ZoomInDown','spice-blocks'), value: 'zoomInDown' },
                                { label: __('ZoomInLeft','spice-blocks'), value: 'zoomInLeft' },
                                { label: __('ZoomInRight','spice-blocks'), value: 'zoomInRight' },
                                { label: __('ZoomInUp','spice-blocks'), value: 'zoomInUp' }
                            ] }
                            onChange={ (userVal) => setAttributes({ AccordionAnimation: userVal }) }					  
                        	/>
							{ AccordionAnimation !="" && (<>  
							<SelectControl
								label={__('Durations','spice-blocks')}
								value={ AccordionDurations }
								options={ [
									{ label: 'Normal', value: ' ' },
									{ label: 'Slow', value: 'slow' },
									{ label: 'Fast', value: 'fast' },
								] }
								onChange={ (userVal) => setAttributes({ AccordionDurations: userVal }) }					  
							/>  
							<TextControl
								label={__('Delay(ms)','spice-blocks')}			    
								value={AccordionDelay}
								onChange={(userVal) => setAttributes({ AccordionDelay: userVal })}
							/>
							</>) }
                    	</PanelBody>
                
						<PanelBody initialOpen={false} title={__('Display','spice-blocks')} className={'spice-panel-edit margin'}>
							<ToggleControl
								label={__('Enable/Disable on Desktop','spice-blocks')}
								checked={HideDesktop}
								onChange={(userVal) => setAttributes({ HideDesktop: userVal })}
							/>
							<ToggleControl
								label={__('Enable/Disable on Tablet','spice-blocks')}
								checked={HideTablet}
								onChange={(userVal) => setAttributes({ HideTablet: userVal })}
							/>
							<ToggleControl
								label={__('Enable/Disable on Mobile','spice-blocks')}
								checked={HideMobile}
								onChange={(userVal) => setAttributes({ HideMobile: userVal })}
							/>
						</PanelBody>	
					</PanelBody>
					<PanelBody initialOpen={false} title={__('Additional Settings','spice-blocks')}>
	                    <InputControl
	                        label={__('Additional Class','spice-blocks')}
	                        value={ addclass }
	                        onChange={ (userVal)=> setAttributes({addclass:userVal}) }
	                    />
	                    <TextareaControl
	                        label={__('Custom CSS','spice-blocks')}
	                        value={ customcss }
	                        onChange={ (userVal)=> setAttributes({customcss:userVal}) }
	                    />
	                </PanelBody>
					
				</InspectorControls>
				<style dangerouslySetInnerHTML={{
			  __html: [
                `#block-${clientId} {
                   max-width:840px;
                }
				#block-${clientId} .components-button:focus:not(:disabled) {
					box-shadow: unset;
					outline: unset;
				}

				#block-${clientId} .img-com-media-wrapper{
					width: ${imgWidth}%;
					margin: ${imgMargin.top} ${imgMargin.right} ${imgMargin.bottom} ${imgMargin.left};
					animation-delay: ${AccordionDelay}ms;
				}
				${customcss}`
			    ].join('\n')
			  }}>
			   </style>
		</>,<>
        <div className={`img-com-media-wrapper ${animationclass} ${displayclass} ${addclass}`}>
            {/* Upload & Load Image*/ }    
			{beforeImageUrl && afterImageUrl ? ( <BlockControls>
			                    <ToolbarGroup>
                                    <MediaUpload
										onSelect={(media) =>
											setAttributes({
												beforeImageUrl: media.url,
												beforeImageId: media.id,
												beforeImageAlt: media.alt,
											})
										}
										allowedTypes={['image']}
										value={beforeImageId}
										render={({ open }) => {
											return (
												<Button
													label={__(
														'Edit Image',
														'image-comparision-block'
													)}
													onClick={open}
													icon="edit"
												/>
											);
										}}
									/>
									<MediaUpload
										onSelect={(media) =>
											setAttributes({
												afterImageUrl: media.url,
												afterImageId: media.id,
												afterImageAlt: media.alt,
											})
										}
										allowedTypes={['image']}Togg
										value={afterImageId}
										render={({ open }) => {
											return (
												<Button
													label={__(
														'Edit Image',
														'image-comparision-block'
													)}
													onClick={open}
													icon="edit"
												/>
											);
										}}
									/>
                                </ToolbarGroup>
                            </BlockControls> ) : ( null )}
			{beforeImageUrl && afterImageUrl ? ( <ReactCompareImage hover={hover} vertical={verticalMode} leftImage={beforeImageUrl} rightImage={afterImageUrl} handleSize={50} leftImageLabel={showLabel ? leftImageLabel : null} rightImageLabel={showLabel ? rightImageLabel : null}/> ) : (    
			<div className="img-com-media-wrapper-panel">                   
            { beforeImageUrl ?  
            (   <div className='img-com-section'>
                    <img src={beforeImageUrl} alt={beforeImageAlt} />
                    { beforeImageUrl ? 
                        ( <MediaUploadCheck> 
                            <BlockControls>
			                    <ToolbarGroup>
                                    <MediaUpload
										onSelect={(media) =>
											setAttributes({
												beforeImageUrl: media.url,
												beforeImageId: media.id,
												beforeImageAlt: media.alt,
											})
										}
										allowedTypes={['image']}
										value={beforeImageId}
										render={({ open }) => {
											return (
												<Button
													label={__(
														'Edit Image',
														'image-comparision-block'
													)}
													onClick={open}
													icon="edit"
												/>
											);
										}}
									/>
									<MediaUpload
										onSelect={(media) =>
											setAttributes({
												afterImageUrl: media.url,
												afterImageId: media.id,
												afterImageAlt: media.alt,
											})
										}
										allowedTypes={['image']}
										value={afterImageId}
										render={({ open }) => {
											return (
												<Button
													label={__(
														'Edit Image',
														'image-comparision-block'
													)}
													onClick={open}
													icon="edit"
												/>
											);
										}}
									/>
                                </ToolbarGroup>
                            </BlockControls>
                        </MediaUploadCheck>) : ( null ) }
                </div>
            ) 
            : 
            (   <MediaUpload
	  			    onSelect={(media) =>
                        setAttributes({
                            beforeImageUrl: media.url,
                            beforeImageId: media.id,
                            beforeImageAlt: media.alt,
                        })
                    }
				    allowedTypes={['image']}
                    value={beforeImageId}
	  			    render={({open})=>
		  		    <Button className="spice-gb-image-button" type="image" onClick={open} >
		  			    <img src={image1} width="100%" />
		  		    </Button>
  				    }
			    />
              )	
            }



            {/* Upload & Load Image*/ }                            
            { afterImageUrl ?  
            (   <div class="img-com-section">
                    <img src={afterImageUrl} alt={afterImageAlt} />
                    { afterImageUrl ? 
                        ( <MediaUploadCheck> 
                            <BlockControls>
			                    <ToolbarGroup>
                                    <MediaUpload
										onSelect={(media) =>
											setAttributes({
												afterImageUrl: media.url,
												afterImageId: media.id,
												afterImageAlt: media.alt,
											})
										}
										allowedTypes={['image']}
										value={afterImageId}
										render={({ open }) => {
											return (
												<Button
													label={__(
														'Edit Image',
														'image-comparision-block'
													)}
													onClick={open}
													icon="edit"
												/>
											);
										}}
									/>
                                </ToolbarGroup>
                            </BlockControls>
                        </MediaUploadCheck>) : ( null ) }
                </div>
            ) 
            : 
            (   <MediaUpload
	  			    onSelect={(media) =>
                        setAttributes({
                            afterImageUrl: media.url,
                            afterImageId: media.id,
                            afterImageAlt: media.alt,
                        })
                    }
				    allowedTypes={['image']}
                    value={afterImageId}
	  			    render={({open})=>
		  		    <Button className="spice-gb-image-button" type="image" onClick={open} >
		  			    <img src={image1} width="100%" />
		  		    </Button>
  				    }
			    />
              )	
            }

			</div>
			) } 
        </div></>]);
    },
    save: function({attributes})
    {
		const { uniqueId, beforeImageId, beforeImageUrl, beforeImageAlt, afterImageId, afterImageUrl, afterImageAlt, hover, showLabel, leftImageLabel, rightImageLabel , verticalMode, AccordionAnimation, AccordionDurations, AccordionDelay, HideDesktop, HideTablet, HideMobile, imgWidth, imgMargin, addclass, customcss } = attributes;
		const animationclass='wow animated ' +attributes.AccordionDurations+' '+attributes.AccordionAnimation;
        const displaydesktop=(HideDesktop == false) ? 'hide-desktop' : '';
        const displaytablet=(HideTablet == false) ? 'hide-tablet' : '';
        const displaymobile=(HideMobile == false) ? 'hide-mobile' : '';
        const displayclass=displaydesktop+' '+displaytablet+' '+displaymobile;
        return (<>
			<style dangerouslySetInnerHTML={{
				__html: [
				  `#spice_block_img_com_${uniqueId}{
					width: ${imgWidth}%;
					margin: ${imgMargin.top} ${imgMargin.right} ${imgMargin.bottom} ${imgMargin.left};
					animation-delay: ${AccordionDelay}ms;
				  }
				  ${customcss}`
				  ].join('\n')
				}}>
			</style>
			<div id={`spice_block_img_com_${uniqueId}`} className={`icgb-compare-block ${animationclass} ${displayclass} ${attributes.className} ${addclass}`}
			data-hover={hover}
			data-label={showLabel}
			data-lil={leftImageLabel}
			data-ril={rightImageLabel}
			data-vertical={verticalMode}
		>
		<img
			src={beforeImageUrl}
			alt={beforeImageAlt}
			className={`wp-image-${beforeImageId}`}
		/>
		<img
			src={afterImageUrl}
			alt={afterImageAlt}
			className={`wp-image-${afterImageId}`}
		/>
	</div></>)
    }

})